import React from "react";
import './SearchHeaderMobile.css'
import BackIcon from "../../../resources/wrappers/BackIcon";
import {Button, Input} from "@material-ui/core";
import { Route } from "react-router-dom";
import SearchIcon from "../../../resources/wrappers/SearchIcon";
import CancelIcon from "../../../resources/wrappers/CancelIcon";

export class SearchHeaderMobile extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            inputValue: "",
            inputFocused: false
        }
        this.handleSearchTextInserted = this.handleSearchTextInserted.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
    }

    private handleSearchTextInserted(event: any){
        this.setState({inputValue: event.target.value});
        this.props.onValueChanged(event.target.value);
    }

    private handleDelete(){
        console.log("[SearchBarMobile] handleDelete called!")
        this.setState({inputValue: ""});
        this.setState({inputFocused: false});
        this.props.onValueChanged("");
    }

    render() {
        return <div className={"main-header"}
                    style={this.props.background ? {background: this.props.background} : {background: 'transparent'}}>
            <div className={"base-header"}>
                <div className={"header-button-left-container"}>
                    <Route render={({history}) => {
                        return <Button id={"left-button-header"} onClick={() => {history.goBack()}} disableRipple>
                            <BackIcon width={"26px"} height={"30px"}
                                      fill={this.props.buttonContentColor ? this.props.buttonContentColor : "#000000"}
                                      stroke={this.props.buttonContentColor ? this.props.buttonContentColor : "#000000"}/>
                        </Button>
                    }}/>
                </div>
                <div className={"header-title-container"}>
                    <Input
                        autoFocus={true}
                        disableUnderline={true}
                        id={"mobile-search-bar-input"}
                        fullWidth
                        rowsMax={1}
                        value={this.state.inputValue}
                        type={this.props.inputType}
                        onChange={this.handleSearchTextInserted}
                        placeholder={this.props.placeholder}
                        onFocus={() => {this.setState({inputFocused: true})}}
                        onBlur={() => {this.setState({inputFocused: false})}}
                    />
                </div>
                <div className={"header-button-right-container"}>
                    <div className={this.state.inputValue.length >= 3 ? "search-bar-icon-container icon-hidden" : "search-bar-icon-container"}>
                        <SearchIcon width={"24px"} height={"24px"} focused={this.state.inputFocused} />
                    </div>
                    <div className={this.state.inputValue.length < 3 ? "search-bar-icon-container icon-hidden" : "search-bar-icon-container"}>
                        <CancelIcon width={"24px"} height={"24px"} focused={false} pointer={'icon-pointer'} onClick={() => {
                            this.handleDelete();
                        }}/>
                    </div>
                </div>
            </div>
        </div>;
    }
}